import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

/** Initials of a display name or e-mail, for the avatar (never a guess at a missing name). */
export function initials(label: string): string {
  const words =
    label
      .split("@")[0]
      ?.split(/[\s._-]+/)
      .filter(Boolean) ?? [];
  return words
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");
}

/**
 * The 32px leading tile of a row: a person's initials on the accent wash, or a neutral icon
 * tile for what is not a person (a group, a rule). Decorative: the row names what it is.
 */
export function Avatar(
  props: ({ name: string; icon?: never } | { icon: LucideIcon; name?: never }) & {
    className?: string;
  },
) {
  const Icon = props.icon;
  return (
    <span
      aria-hidden="true"
      className={cn(
        "grid size-8 shrink-0 place-items-center rounded-md text-xs font-semibold",
        Icon ? "bg-surface-sunken text-fg-secondary" : "bg-accent-subtle text-accent-text",
        props.className,
      )}
    >
      {Icon ? <Icon className="size-4" strokeWidth={1.75} /> : initials(props.name ?? "")}
    </span>
  );
}
